export class OverlayManager {
    public preventScroll() {
        document.body.style.overflow = 'hidden';
        document.documentElement.style.overflow = 'hidden';
        document.body.style.touchAction = 'pan-x';
        document.documentElement.style.touchAction = 'pan-x';
    }
    public enableScroll() {
        document.body.style.overflow = '';
        document.documentElement.style.overflow = '';
        document.body.style.touchAction = '';
        document.documentElement.style.touchAction = '';
    }

    public showRocketOverlayBackground() {
        if (!document.getElementById('rocket_overlay')) {
            let overlay = document.createElement('div');
            overlay.id = 'rocket_overlay';
            document.body.prepend(overlay);
        }

        let overlay = document.getElementById('rocket_overlay') as HTMLDivElement;
        let h = document.body.scrollHeight;
        overlay.style.height = h + 'px';
        overlay.style.width = '100vw';
        overlay.style.display = 'block';

        // prevent scroll on ios devices
        overlay.style.touchAction = 'pan-x';
    }

    public hideRocketOverlayBackground() {
        let overlay = document.getElementById('rocket_overlay') as HTMLDivElement;
        overlay.style.display = 'none';
    }
}
